import gql from "graphql-tag";

export default gql`query Teams($archived:Boolean!) {
    teams(archived:$archived) {
        id
        code 
        name
    }
  }`